
import styles from "../../../../AccountingPage.module.scss";
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import Notification from "utils/Notifications";
import { Button } from 'components'
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";

import { getSpecialitiesData, postSpecialitiesData, deleteSpecialitiesData, patchSpecialitiesData } from "service/AccountingService";
import ModalWindow from "hooks/ModalWindow/ModalWindow";

import SpecialityContent from "./components/SpecialityContent"
import { Icon } from '../../../../../../components/UnvUI/Icons'

const DepartmentContent = ({ render, setRender, id, onBack1, nameStruct, nameBranch }) => {
  const { t } = useTranslation('common')

  const componentRef = useRef();
  const [openModal, setOpenModal] = useState(false);


  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [data, setData] = useState([]);
  const getData = async (id) => {
    try {
      let response = await getSpecialitiesData(id, data);
      setData(response.data);

    } catch (error) {
    }
  };

  const [name, setName] = useState("");


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!name) {
      setNotify({
        isOpen: true,
        message: "Введите наименование!",
        type: "error",
      });

    }


    else {
      const formData = new FormData();
      formData.append('name', name);

      let data = await postSpecialitiesData(id, formData);

      getData();


      setName("");

      setOpenModal(false)

      setNotify({
        isOpen: true,
        message: "Специальность успешно создана!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };

  useEffect(() => {

    getData(id);

    setRender(false);


  }, [render]);


  const [searchName, setSearchName] = useState('');

  const filteredData = Array.isArray(data)
    ? data.filter((item) => {
      const matchName = item.name?.toLowerCase().includes(searchName.toLowerCase());
      return matchName;
    })
    : [];

  const clearFilters = () => {
    setSearchName('');
    setCurrentPage(1);
  };


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);


  const [editRowId, setEditRowId_Set] = useState(null);
  const [name_edit, setNameEdit] = useState('');


  const setEditRowId = (item) => {
    setNameEdit(item.name)
    setEditRowId_Set(item.id)
  };


  const onDelete = async (id) => {
    let data = await deleteSpecialitiesData(id);
    setNotify({
      isOpen: true,
      message: "Специальность успешно удалена!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };

  const onSave = async (id) => {
    const formData = new FormData();
    formData.append('name', name_edit);

    let data = await patchSpecialitiesData(id, formData);


    getData()
    setNameEdit("");
    setOpenModal(false)

    setNotify({
      isOpen: true,
      message: "Специальность успешно изменена!",
      type: "success",
      sound: "success"
    });
    setRender(true)
    setEditRowId_Set(null);
  };


  const [openSpecialityId, setOpenSpecialityId] = React.useState(null);
  const [openSpecialityName, setOpenSpecialityName] = React.useState(null);

  const handleOpenSpeciality = (item) => {
    setOpenSpecialityId(item.id);
    setOpenSpecialityName(item.name);
  };

  const handleCloseSpeciality = () => {
    setOpenSpecialityId(null);
    setOpenSpecialityName('');
  };

  return (
    <>
      {!openSpecialityId && (
        <>
          <div className={styles.content_header}>
            <div className={styles.content_header_in}>
              <Button className={styles.btn_pin} onClick={onBack1}>⬅ Назад</Button>
              <h2 className={styles.project__h}>Структура/{nameStruct}/{nameBranch}</h2>
            </div>
            <button className={styles.btn_print} onClick={handlePrint}>{t('auto.components_academicyearcontent.k1')} </button>


            <Button className={styles.btn_pin} onClick={() => setOpenModal(true)} >
              Добавить специальность
            </Button>
          </div>

          <div className={styles.div_search}>
            <h2 className={styles.project__h}>{t('common.filter')}</h2>
            <div>
              <input
                type="text"
                placeholder={t('auto.components_academicyearcontent.k2')}
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                style={{ width: "30%" }}
              />
              <Button onClick={clearFilters} className={styles.clear__button} >
                Очистить
              </Button>

            </div>


          </div>

          <table ref={componentRef} className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item}>№</th>

                <th className={styles.table__item}>
                  <span className={styles.table__title}>{t('auto.components_departmentcontent.k1')}</span>
                </th>
                <th className={styles.table__item}>
                  <span className={styles.table__title}>{t('statementsPage.dateCreated')} </span>
                </th>

                <th className={styles.table__item__nav} >
                  <span className={styles.table__title}>{t('common.actions')}</span>
                </th>
              </tr>
            </thead>

            <tbody className={styles.table__body}>
              {currentItems.map((item, index) => (

                <tr className={styles.table__row} key={item.id}>
                  <td className={styles.table__item}>
                    <span className={styles.table__title}>
                      {index + 1 + (currentPage - 1) * itemsPerPage}
                    </span>
                  </td>
                  {editRowId === item.id ? (
                    <>

                      <td className={styles.table__item}>
                        <input
                          type="text"
                          value={name_edit}
                          onChange={(e) => setNameEdit(e.target.value)}
                          placeholder={t('structure.name')}
                          className={styles.edit_input}
                        />
                      </td>
                      <td className={styles.table__item}>{item.created_at}</td>
                      <td className={styles.table__item__nav} >
                        <div className={styles.table__item__div}>
                          <button onClick={() => onSave(item.id)} className={styles.saveBtn}><Icon name="save" /> </button>
                          <button onClick={() => setEditRowId_Set(null)} className={styles.cancelBtn}>
                            <Icon name="close" />
                          </button>
                          <button onClick={() => onDelete(item.id)} className={styles.deleteBtn}><Icon name="delete" /></button>
                        </div>
                      </td>

                    </>
                  ) : (
                    <>
                      <td className={styles.table__item}>
                        <span className={styles.table__title} style={{ fontWeight: '700' }}>
                          {item.name}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.created_at}</span>
                      </td>

                      <td className={styles.table__item}>
                        <div className={styles.table__item__div}>
                          <button onClick={() => setEditRowId(item)} className={styles.editBtn}><Icon name="edit" /> </button>
                          <button onClick={() => handleOpenSpeciality(item)} className={styles.editBtn}><Icon name="folder" /> </button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}

              

            </tbody>
            <div className={styles.pagination}>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  style={{
                    padding: '5px 10px',
                    background: currentPage === page ? '#736CED' : '#f0f0f0',
                    color: currentPage === page ? '#fff' : '#000',
                    border: '1px solid #ccc',
                    borderRadius: "6px",
                    cursor: 'pointer',
                  }}
                >
                  {page}
                </button>
              ))}
            </div>


          </table>
        </>
      )}

      {openSpecialityId && (
        <SpecialityContent
          id={openSpecialityId}
          render={render}
          setRender={setRender}
          onBack2={handleCloseSpeciality}  
          nameStruct={nameStruct}
          nameBranch={nameBranch}
          nameDepartment={openSpecialityName}
        />
      )}
      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={'Новая специальность'}
      >
        <>
          <div className={styles["note-input"]}>

            <form onSubmit={handleSubmit} >
              <div className={styles.form_input}>
                <input
                  type="text"
                  placeholder={t('auto.components_academicyearcontent.k3')}

                  value={name}
                  name="name"
                  onChange={(e) => setName(e.target.value)}
                />


              </div>


              <div className={styles.create_footer}>


                <button
                  type="submit"
                  className={styles.open_btn_sub}

                >
                  {t('common.create')}
                </button>
              </div>
            </form>
          </div>
          <Button
            onClick={() => setOpenModal(false)}
            className={styles.close_btn_sub}
          >
            {" "}
            Закрыть
          </Button>
        </>
      </ModalWindow>
      <Notification notify={notify} setNotify={setNotify} />


    </>


  );
};

export default DepartmentContent;
